import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'name',
      type: 'input',
      label: '名字',
      placeholder: '请输入名字',
      rules: { required: true, message: '名字是必传的', trigger: 'blur' }
    },
    {
      field: 'enName',
      type: 'input',
      label: '简写',
      placeholder: '请输入简写',
      rules: { required: true, message: '简写是必传的', trigger: 'blur' }
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
